import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 bg-white" data-id="element-84" data-mp="1o3x23lbnuo1h">
      <div className="max-w-3xl mx-auto" data-id="element-85" data-mp="1o33teet55ogp">
        <div className="bg-brand-cloud border border-brand-gold/40 p-5 sm:p-6 rounded-2xl text-center shadow-sm" data-id="element-86" data-mp="223epbw9b5t8q">
          <p className="text-xs sm:text-sm font-extrabold text-brand-blue uppercase tracking-widest mb-2" data-id="element-87" data-mp="1x3tp7iiejeuf">
            Your Investment Is 100% Protected
          </p>
          <div className="w-14 h-14 mx-auto bg-brand-blue/10 rounded-full flex items-center justify-center mb-2" data-id="element-88" data-mp="19ceg96w4dza7">
            <ShieldCheckIcon className="w-7 h-7 text-brand-blue" data-id="element-89" data-mp="1j4k9sl20sori" />
          </div>
          <h3 className="text-xl sm:text-2xl font-display font-extrabold text-brand-ink mb-3 uppercase" data-id="element-90" data-mp="1j6dgg0cmv8zi">
            🛡️ 7-Day Money-Back Guarantee
          </h3>
          <div className="text-sm sm:text-base text-brand-slate font-medium max-w-2xl mx-auto leading-snug space-y-2" data-id="element-91" data-mp="qmycmap51qpk">
            <p data-id="element-92" data-mp="lowm54pdup42">Your purchase is completely risk-free.</p>
            <p data-id="element-93" data-mp="p0b6ptplh6ew">
              Take seven full days to explore the entire system, review every
              module, organize your practices, implement the coaching resources,
              and start using the complete planning system with your athletes.
            </p>
            <p data-id="element-94" data-mp="12qwrjnylzqff">
              If for any reason you're not completely satisfied, simply contact
              us within the first 7 days and we'll refund 100% of your purchase.
            </p>
            <p className="font-bold text-brand-navy uppercase tracking-wide" data-id="element-95" data-mp="azqp30vf1gmz">
              No risk. No questions asked.
            </p>
          </div>
        </div>
      </div>
    </section>;
}